// Persists the Excel refresh token using OfficeRuntime.storage when available,
// falling back to localStorage. The access token is never persisted.

const REFRESH_TOKEN_KEY = 'excel_refresh_token';

// OfficeRuntime is injected by the Office host at runtime and is not in @types/office-js
declare const OfficeRuntime: {
  storage: {
    setItem(key: string, value: string): Promise<void>;
    getItem(key: string): Promise<string | null>;
    removeItem(key: string): Promise<void>;
  };
} | undefined;

function useOfficeStorage(): boolean {
  try {
    return typeof OfficeRuntime !== 'undefined' && !!OfficeRuntime?.storage;
  } catch {
    return false;
  }
}

export async function saveRefreshToken(token: string): Promise<void> {
  if (useOfficeStorage()) {
    await OfficeRuntime!.storage.setItem(REFRESH_TOKEN_KEY, token);
  } else {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }
}

export async function loadRefreshToken(): Promise<string | null> {
  if (useOfficeStorage()) {
    return await OfficeRuntime!.storage.getItem(REFRESH_TOKEN_KEY);
  }
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export async function clearRefreshToken(): Promise<void> {
  if (useOfficeStorage()) {
    await OfficeRuntime!.storage.removeItem(REFRESH_TOKEN_KEY);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
}
